import cookies from 'utils/cookies';

var __cookieName = 'dealer_code_rti_code';

function __savedDealerCode() {
  var saved = cookies.getItem(__cookieName);
  if (!saved) {
    return null;
  }
  return cookies.getItem(__cookieName);
}

var rtiDealerCode = {
  hasRti: () => __savedDealerCode() && __savedDealerCode() !== 'false',
  savedDealerCode: () => __savedDealerCode()
};

export default rtiDealerCode;
